import { useQuery } from '@tanstack/react-query';
import DropdownMenu from '../../common/Dropdown.jsx';
import { FaIcon } from '../../common/Icons.jsx';
import { fetchJson } from '../../../helpers/fetch.js';

import {
  pivot_datagrid_configs_path,
  pivot_datagrid_show_path
} from '~/routes';

function PivotEditsDropdown({ datagridId }) { 
  const { data, refetch } = useQuery({
    queryKey: ['pivot_datagrid_configs', datagridId],
    queryFn: () => fetchJson(pivot_datagrid_configs_path({ id: datagridId, _options: true})),
    enabled: true,
    staleTime: 30_000
  });

  return (<>
  {(data && data.length > 0) &&
    <DropdownMenu
      btnType='default'
      btnStyle={{maxHeight: '100%'}}
      label={<>
        {I18n.t('pivot_datagrids')}
        <FaIcon type='caret-down' />
      </>}
      containerClass='column-selector d-inline-block'
    >
      {(data || []).map((t) => (
        <li key={t.id} className='dropdown-item'>
          <a
            className='no-style cursor-pointer'
            href={pivot_datagrid_show_path({id: datagridId, pivot_edit_id: t.id, _options: true})}
          >
            {t.name}
          </a>
        </li>
      ))}
    </DropdownMenu>}
  </>)
}

export default PivotEditsDropdown;
